/* eslint-disable */
import * as THREE from 'three'
import r from './r.js'
import r1 from './r1.js'
import b from './b.js'
import { h397 } from './h.js'
import p from './p.js'
import v from './v.js'
import f from './f.js'
import g from './g.js'
import m from './m.js'
import o from './runs.js'
import i from './rr.js'

var s = function (e) {
  function d(e) {
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, d);

    b.default.create()

    var t = e.querySelector("canvas")
      , n = function (e, t) {
        if (!e)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t
      }(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, "sea-scene", t, {
        ratio: .5,
        renderer: {
          alpha: !1,
          bgColor: 332063
        }
      }));
    n.ref = e,
      n.scene = n.ref.querySelector(".scene"),
      n.mouseRatio = {
        x: 0,
        y: 0
      },
      n.ratio = {
        x: 0,
        y: 0
      },
      n.shiftedRatio = {
        x: 0,
        y: 0
      },
      n.targetPiValue = {
        x: 0,
        y: 0
      },
      n.sceneOffsetBottom = 200,
      n.needToUpdateTargetPiValue = !1;
    var i = new THREE.PlaneGeometry(256, 256)
      , r = new THREE.PlaneGeometry(1024, 512)
      , o = new THREE.MeshBasicMaterial({
        map: b.default.get("/images/sc1-sky-p2.jpg"),
        transparent: !1
      })
      , a = new THREE.MeshBasicMaterial({
        map: b.default.get("/images/sc1-birdfront_P2.png"),
        transparent: !0
      })
      , s = new THREE.MeshBasicMaterial({
        map: b.default.get("/images/sc1-birdback_P2.png"),
        transparent: !0
      })
      , l = new THREE.MeshBasicMaterial({
        map: b.default.get("/images/sc1-mountain_P2.png"),
        transparent: !0
      })
      , u = new THREE.MeshBasicMaterial({
        map: b.default.get("/images/flare-big-p2.png"),
        transparent: !0
      })
      , c = h397;
      // console.log(hh)
    return n.bg = new p.default("texture-sea2-p2.png", "map-sea-p2.jpg", {
      w: 1920,
      h: 929,
      wave: !0
    }),
      n.bg.material.fragmentShader = c,
      n.sky = new THREE.Mesh(new THREE.PlaneGeometry(1920, 698), o),
      n.mountain = new v.default(r, l, {
        ox: -468,
        oy: 85,
        depth: 0
      }),
      n.frontBird = new f.default(i, a, {
        ox: 620,
        oy: -10,
        depth: 4.5
      }),
      n.backBird = new f.default(i, s, {
        ox: 720,
        oy: 200,
        depth: 9
      }),
      n.bigLight = new THREE.Mesh(new THREE.PlaneGeometry(1983, 1935), u),
      n.flare = new g.default,
      n.lens = new m.default,
      n.app.scene.add(n.sky),
      n.app.scene.add(n.bigLight),
      n.app.scene.add(n.flare),
      n.app.scene.add(n.mountain),
      n.app.scene.add(n.bg),
      n.app.scene.add(n.frontBird),
      n.app.scene.add(n.backBird),
      n.app.scene.add(n.lens),
      n.sky.position.z = -5,
      n.bigLight.position.z = -3,
      n.mountain.position.z = -2,
      n.flare.position.z = -4,
      n.bg.position.z = -1,
      n.autoMove = {
        x: 0,
        y: 0
      },
      n.autoOffset = {
        x: 0,
        y: 0
      },
      n.resize(),
      n
  }
  return function (e, t) {
    if ("function" != typeof t && null !== t)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }),
      t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
  }(d, r.default),
    r1(d, [{
      key: "render",
      value: function () {
        // console.log('render')
        this.mouseRatio.x = window.mouse.x / this.view.width * 2 - 1 + .65 * this.autoOffset.x,
          this.mouseRatio.y = window.mouse.y / this.view.height * 2 - 1 + .65 * this.autoOffset.y,
          this.ratio.x += .06 * (this.mouseRatio.x - this.ratio.x),
          this.ratio.y += .07 * (this.mouseRatio.y - this.ratio.y),
          this.shiftedRatio.x = this.ratio.x,
          this.shiftedRatio.y += .07 * (this.mouseRatio.y - .25 * this.autoOffset.y - this.ratio.y),
          this.bg.render(this.autoOffset),
          this.mountain.parallax(this.ratio),
          this.frontBird.parallax(this.shiftedRatio),
          this.backBird.parallax(this.ratio),
          this.flare.parallax(this.ratio),
          this.lens.parallax(this.ratio),
          this.bigLight.material.opacity = this.flare.alpha,
          o.default.getSpeed(),
          0 === window.mouseSpeed.x && 0 === window.mouseSpeed.y ? (this.targetPiValue.x = this.targetPiValue.y = 0,
            this.autoMove.y += .0255,
            this.autoMove.x += .003,
            this.needToUpdateTargetPiValue = !0) : (this.needToUpdateTargetPiValue && (this.targetPiValue.x = Math.ceil(this.autoMove.x / Math.PI) * Math.PI,
              this.targetPiValue.y = Math.ceil(this.autoMove.y / Math.PI) * Math.PI),
              this.needToUpdateTargetPiValue = !1,
              this.autoMove.x += .1 * (this.targetPiValue.x - this.autoMove.x),
              this.autoMove.y += .1 * (this.targetPiValue.y - this.autoMove.y)),
          this.autoOffset.x += .05 * (Math.sin(this.autoMove.x) - this.autoOffset.x),
          this.autoOffset.y += .05 * (Math.sin(this.autoMove.y) - this.autoOffset.y),
          i(d.prototype.__proto__ || Object.getPrototypeOf(d.prototype), "render", this).call(this)
      }
    }, {
      key: "resize",
      value: function () {
        var e = this.bg.image.width
          , t = this.bg.image.height + 290
          , n = window.w / e
          , i = window.w
          , r = t * n >> 0
          , o = i >> 1
          , a = r >> 1;
        this.sky.position.y = a - 349 * n,
          this.sky.scale.x = this.sky.scale.y = n,
          this.bg.resize(),
          this.bg.position.y = -290 * n + (r - this.bg.scale.y >> 1),
          this.flare.oPosition.x = 450 * n - o,
          this.flare.oPosition.y = 260 * n,
          this.bigLight.position.x = this.flare.oPosition.x,
          this.bigLight.position.y = 130 * n,
          this.mountain.resize(n),
          this.frontBird.resize(n),
          this.backBird.resize(n),
          this.locate(),
          this.app.resize(i, r),
          this.ref.style.height = this.scene.style.height = r + this.sceneOffsetBottom + "px"
      }
    }, {
      key: "dispose",
      value: function () {
        this.app.scene.remove(this.sky, this.bigLight, this.flare, this.mountain, this.bg),
          this.app.scene.remove(this.frontBird, this.backBird, this.lens),
          this.frontBird.dispose(),
          this.frontBird = null,
          this.backBird.dispose(),
          this.backBird = null,
          this.mountain.dispose(),
          this.mountain = null,
          this.bg.dispose(),
          this.bg = null,
          this.flare.dispose(),
          this.flare = null,
          this.lens.dispose(),
          this.lens = null,
          this.bigLight.geometry.dispose(),
          this.bigLight.material.dispose(),
          this.bigLight = null,
          this.sky.geometry.dispose(),
          this.sky.material.dispose(),
          this.sky = null,
          this.ratio = this.mouseRatio = this.targetPiValue = this.shiftedRatio = this.autoMove = this.needToUpdateTargetPiValue = this.autoOffset = null,
          this.scene = this.ref = null,
          this.app.dispose(),
          this.app = null,
          i(d.prototype.__proto__ || Object.getPrototypeOf(d.prototype), "dispose", this).call(this)
      }
    }]),
    d
}();

export default s

// export default class SceneSea {
//   constructor (e) {
//     this.ref = e
//   }

//   render () {

//   }

//   resize () {

//   }

//   dispose () {

//   }
// }
